import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const ToggleOpenClose = ({
  className,
  openLabel,
  closeLabel,
  isOpen,
  onClose,
  onOpen,
}) => (
  <div className={`${className ? `${className} ` : ''}ToggleOpenClose ${isOpen ? 'active' : ''}`}>
    <button type="button" className="ToggleOpenClose_open" onClick={onOpen}>
      <div className="ToggleOpenClose_buttonIcon">
        <Icon name="PlusExpand" className="ToggleOpenClose_iconOpen" />
      </div>
      <h4 className="ToggleOpenClose_text">{openLabel}</h4>
    </button>
    <button type="button" className="ToggleOpenClose_close" onClick={onClose}>
      <div className="ToggleOpenClose_buttonIcon">
        <Icon name="MinusCollapse" className="ToggleOpenClose_iconClose" />
      </div>
      <h4 className="ToggleOpenClose_text">{closeLabel}</h4>
    </button>
  </div>
);

ToggleOpenClose.propTypes = {
  className: PropTypes.string,
  closeLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  openLabel: PropTypes.string,
};

export default ToggleOpenClose;
